<template>
    <div class="epf-filter__select" :class="additionalClass">
        <div class="epf-filter__select__title">{{filterConfig.title}}</div>

        <template v-if="filterConfig.type === 'colorselect'">
            <template v-if="selectedOption">
                <div class="epf-filter__select__selection epf-filter__select__selection--color">
                    <span class="swatches">
                        <span v-if="'colors' in selectedOption" v-for="color in selectedOption.colors" class="swatch" :style="'background-color: #' + color + ';'"></span>
                        <span v-if="'title' in selectedOption" class="swatch__title" v-html="selectedOption.title || selectedOption" />
                        <span v-else class="swatch__title">{{selectedOption}}</span>
                    </span>
                    <global-button icon="close" theme="primary" class="epf-filter__select__clear" @click="onClearSelection" :disabled="freeze" v-if="showDeselect" />
                </div>
            </template>
            <template v-else>
                <global-dropdown :options="availableOptionsForDropdown"
                                 @change="onOptionSelection"
                                 :initial-title="$t('filter.dropdown.pleaseSelect')"
                                 :selected-option="selectedOptionForDropdown"
                                 :disabled="freeze || availableOptionsForDropdown.length === 0"
                                 />
            </template>
        </template>
        <template v-else>
            <template v-if="selectedOption">
                <div class="epf-filter__select__selection">
                    <span v-html="selectedOption.title || selectedOption" />
                    <global-button icon="close" theme="primary" class="epf-filter__select__clear" @click="onClearSelection" :disabled="freeze" v-if="showDeselect" />
                </div>
            </template>
            <template v-else>
                <global-dropdown :options="availableOptionsForDropdown"
                                 @change="onOptionSelection"
                                 :initial-title="$t('filter.dropdown.pleaseSelect')"
                                 :selected-option="selectedOptionForDropdown"
                                 :disabled="freeze || availableOptionsForDropdown.length === 0" />
            </template>
        </template>
    </div>
</template>

<script lang="ts">
import {mapState} from 'vuex';
import GlobalButton from "../../../../../global/global-elements/global-button/global-button.vue";
import GlobalDropdown from "../../../../../global/global-elements/global-dropdown/global-dropdown.vue";
import type {Productfinder} from "../../../../../_types/productfinder";
import Vue from "vue";

interface DropdownOption {
    key: string
    title: string
}

export default Vue.extend({
    name: "DecorfinderFilterSelect",
    components: {GlobalButton, GlobalDropdown},
    props: {
        filterConfig: {
            type: Object as () => Productfinder.Filter
        },
        additionalClass: {
            type: String,
            default: ""
        },
        freeze: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            default: ''
        },
        availableOptionValues: {
            type: Array as () => string[],
            default: []
        },
    },
    computed: {
        showDeselect(): boolean {
            // Der einfache Fall: Es gibt überhaupt immer nur eine (oder keine) Option.
            if (this.filterConfig?.options.length <= 1) {
                return false;
            }
            // Der schwierige Fall: Es ist nur eine "available" - da muss man unterscheiden zwischen
            if (this.availableOptionValues.length <= 1) {
                // Der Filter ist ausgewählt
                if (this.value) {
                    return true;
                }
                // Der Filter ist nicht ausgewählt
                return false;
            }
            return true;
        },
        selectedOption(): Productfinder.FilterOption | null {
            if (this.availableOptionValues.length === 1) {
                return this.availableOptions[0]
            }
            if (this.value) {
                return this.availableOptions.find((option: Productfinder.FilterOption) => {
                    let val = typeof option !== 'string' ? option.value : option;
                    if (typeof val === 'number') {
                        return val === parseInt(this.value);
                    }
                    return val === this.value;
                }) || null;
            }
            return null;
        },
        selectedOptionForDropdown(): DropdownOption | null {
            const option = this.selectedOption;
            if (typeof option === 'string') {
                return {
                    key: option,
                    title: option
                };
            }
            else if (option) {
                return {
                    key: option.value,
                    title: option.title
                };
            }
            return null;
        },
        availableOptions(): Productfinder.FilterOption[] {
            let availableOptions = this.filterConfig?.options || [];
            if(Array.isArray(this.availableOptionValues)) {
                availableOptions = availableOptions.filter((option) => {
                    if (typeof option !== 'string') {
                        return this.availableOptionValues.includes(option.value);
                    }
                    else {
                        return this.availableOptionValues.includes(option);
                    }
                });
            }
            return availableOptions;
        },
        availableOptionsForDropdown(): DropdownOption[] {
            return this.availableOptions.map((option) => {
                if (typeof option !== 'string' && "colors" in option) {
                    let swatchTitle = '<span class="swatches">';
                    for (let color of option.colors) {
                        swatchTitle += `<span class="swatch" style="background-color: #${color};"></span>`;
                    }
                    swatchTitle += `<span class="swatch__title">${option.title || option.value || option}</span>`
                    swatchTitle += '</span>';
                    return {
                        key: option.value,
                        title: swatchTitle
                    }
                }
                if (typeof option === 'string') {
                    return {
                        key: option,
                        title: option
                    }
                }
                return {
                    key: option.value,
                    title: option.title || option.value
                }
            });
        }
    },
    methods: {
        onOptionSelection(dropdownOption: DropdownOption) {
            this.$emit('input', dropdownOption.key);
            // this.$store.dispatch('setFilterState', {
            //     filterName: this.filterConfig.name,
            //     value: dropdownOption.key
            // });
        },
        onClearSelection() {
            this.$emit('input', null);
            // this.$store.dispatch('setFilterState', {
            //     filterName: this.filterConfig.name,
            //     value: null
            // });
        }
    }
})
</script>
